import { createApplicationFormSelector } from './createApplicationFormSelector';


export const selectSMSCode = (state) => createApplicationFormSelector(state, 'sms_code');
